import {
  getBrowserVersion,
  getOSVersion,
  isChromecast,
  isKepler,
  isMagentaG3,
  isMagentaG4,
  isMagentaG5,
  isSkyQ,
  isSkyXiOne,
  isTelecolumbusSTB,
  isTizen,
  isVodafoneGTV,
  isVodafoneVTV,
  isWebOS,
} from '@foundation-player/platform-check';
import { Platform } from '@foundation-player/runtime';

/**
 * Detect what platform the player is on.
 * @returns The name of the detected platform. Defaults to web, when no platform could be detected.
 */
export const detectPlatform = (): Platform => {
  if (isMagentaG5()) {
    return Platform.MagentaG5;
  }
  if (isMagentaG4()) {
    return Platform.MagentaG4;
  }
  if (isMagentaG3()) {
    return Platform.MagentaG3;
  }
  if (isVodafoneGTV()) {
    return Platform.VodafoneGTV;
  }
  if (isVodafoneVTV()) {
    return Platform.VodafoneVTV;
  }
  if (isSkyQ()) {
    return Platform.SkyQ;
  }
  if (isSkyXiOne()) {
    // Sky Stream will identify as Sky XiOne.
    return Platform.SkyXiOne;
  }
  if (isChromecast()) {
    return Platform.Chromecast;
  }
  if (isTelecolumbusSTB()) {
    return Platform.TeleColumbus;
  }
  if (isKepler()) {
    return Platform.Kepler;
  }

  const osVersion = getOSVersion();

  if (isTizen()) {
    switch (osVersion) {
      case '3.0':
        return Platform.Tizen3;
      case '4.0':
        return Platform.Tizen4;
      case '5.0':
        return Platform.Tizen5;
      case '5.5':
        return Platform.Tizen5_5;
      case '6.0':
        return Platform.Tizen6;
      case '6.5':
        return Platform.Tizen6_5;
      case '7.0':
        return Platform.Tizen7;
      case '8.0':
        return Platform.Tizen8;
      case '9.0':
        return Platform.Tizen9;
      default:
        return Platform.Tizen3;
    }
  }

  const majorBrowserVersion = getBrowserVersion().split('.')[0];

  if (isWebOS()) {
    // assumption: browser is chromium as always on WebOS

    switch (majorBrowserVersion) {
      case '38':
        return Platform.WebOS3;
      case '53':
        return Platform.WebOS4;
      case '68':
        return Platform.WebOS5;
      case '79':
        return Platform.WebOS6;
      case '87':
        return Platform.WebOS22;
      case '94':
        return Platform.WebOS23;
      case '108':
        return Platform.WebOS24;
      case '120':
        return Platform.WebOS25;
      default:
        return Platform.WebOS3;
    }
  }

  return Platform.Web;
};
